import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Peter Noble
 * id E9D05E0B-362E-4D08-A812-D8A6C8D8F0DB
 * name record-circle-outline
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/record-circle-outline.svg
 * tags
 */
export const RecordCircleOutlineIcon = createSvgIcon(<><path d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9Z" /></>, 'RecordCircleOutlineIcon');
export default RecordCircleOutlineIcon